import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [CommonModule, HttpClientModule, HttpClientJsonpModule],
  exports: [HttpClientModule],
})
export class NiloDataModelModule {}
